module.exports = __webpack_public_path__ + "static/img/product3.b4562416.png";